import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/thumbs-up': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M466.3 286.7c4.7 22.6 0.9 44.5-9 63 3 23.9-4 48.6-17.3 67-1 55.9-35.8 95.3-112.9 95.3-7 0-15 0-22.2 0-102.7 0-133.3-38.9-177.8-39.9-3.6 13.8-16.1 24-31 24h-64c-17.7 0-32-14.3-32-32v-240c0-17.7 14.3-32 32-32h98.8c19.1-17 46-60.7 68.8-83.4 13.7-13.7 10.2-108.6 71.8-108.6 57.6 0 95.3 31.9 95.3 104.7 0 18.4-3.9 33.7-8.8 46.5h36.5c48.6 0 85.8 41.6 85.8 85.6 0 19.2-5 35-13.7 49.8zM404.5 340.5c21.6-20.4 18.7-51.1 5.2-65.6 9.4 0 22.4-18.9 22.3-37.8-0.1-18.9-16.7-37.8-37.8-37.8h-104c0-37.8 28.4-55.4 28.4-94.5 0-23.8 0-56.7-47.3-56.7-18.9 18.9-9.5 66.2-37.8 94.5-26.6 26.6-66.2 97.5-94.5 97.5h-10.9v186.2c53.6 0 100 37.8 171.6 37.8h37.8c35.5 0 60.8-17.1 53.1-65.9 15.2-8.2 26.5-36.4 13.9-57.6zM88 432c0-13.3-10.7-24-24-24s-24 10.7-24 24 10.7 24 24 24 24-10.7 24-24z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/thumbs-up.js
// module id = 1825
// module chunks = 0